import { render, staticRenderFns } from "./TermsWidget.vue?vue&type=template&id=00d38ead&scoped=true"
import script from "./TermsWidget.vue?vue&type=script&lang=js"
export * from "./TermsWidget.vue?vue&type=script&lang=js"
import style0 from "./TermsWidget.vue?vue&type=style&index=0&id=00d38ead&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00d38ead",
  null
  
)

export default component.exports